/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'gatsby';
import { SVGRender } from '../../../helper/image';
import { Wrapper } from './style';
import { currentYear } from '../../../helper/time';

const Footer = () => {
	return (
		<Wrapper>
			<section id="footer" className="footer">
				<div className="container">
					<div className="row footer__main-wrapper">
						<div className="footer__logo col-12">
							<img
								alt=""
								src="https://seiturju.sirv.com/Chatbiz/logo-footer.svg"
								className="img-fluid footer__logo--image g-image"
							/>
						</div>
						<div className="footer__wrapper col-sm-12 col-md-8">
							<div className="footer__nav">
								<div className="footer__nav__items">
									<h5 className="footer__nav__items--title">Company</h5>
									<Link to="/about-us" className="item-link" id="mtFooterAboutUs">
										About Us
									</Link>
									<a
										href="/blog/kategori/portofolio"
										target="_blank"
										rel="noreferrer"
										className="item-link"
										id="mtFooterPortofolio"
									>
										Portofolio
									</a>
									<a
										href="https://chatnshop.id"
										target="_blank"
										rel="noreferrer"
										className="item-link"
										id="mtFooterChatbizTech"
									>
										ChatNShop
									</a>
								</div>
								<div className="footer__nav__items">
									<h5 className="footer__nav__items--title">Resources</h5>
									<a href="/blog" target="_blank" rel="noreferrer" className="item-link" id="mtFooterBlog">
										Blog
									</a>
									<a
										href="/white-paper"
										target="_blank"
										rel="noreferrer"
										className="item-link"
										id="mtFooterWhitePaper"
									>
										Whitepaper
									</a>
									<a
										href="https://tech.chatbiz.id"
										target="_blank"
										rel="noreferrer"
										className="item-link"
										id="mtFooterChatbizTech"
									>
										Chatbiz.id Tech
									</a>
								</div>
								<div className="footer__nav__items">
									<h5 className="footer__nav__items--title">Others</h5>

									<Link to="/privacy-policy" className="item-link" id="mtFooterKebijakanPrivasi">
										Privacy Policy
									</Link>
									<Link to="/terms-of-service" className="item-link" id="mtFooterKetentuanLayanan">
										Term of Service
									</Link>
								</div>
							</div>
							<div className="footer__copyright mt-auto">
								<h6 className="font-weight-normal mb-0">
									© {currentYear()} Chatbiz.id. All Rights Reserved.
								</h6>
							</div>
						</div>
						<div className="col-sm-12 col-md-4">
							<div className="footer__info">
								<h5 className="footer__info__title">PT Pemuda Inovasi Teknologi</h5>
								<p className="footer__info__text">
									Jl. Gelap Nyawang No.1, Lb.
									<br />
									Siliwangi, Kecamatan <br />
									Coblong, Kota Bandung, <br />
									Jawa Barat 40132
								</p>
							</div>
							<div className="footer__info__sns">
								<a
									href="https://wa.me/"
									target="_blank"
									rel="noreferrer"
									className="footer__info__sns--link"
									id="mtFooterLinkWA"
								>
									{SVGRender(
										'https://seiturju.sirv.com/Chatbiz/whatsapp.svg',
										'footer__info__sns--image g-image',
										20,
										21,
										'',
									)}
								</a>
								<a
									href="https://instagram.com/chatbiz.id"
									target="_blank"
									rel="noreferrer"
									className="footer__info__sns--link"
									id="mtFooterLinkIG"
								>
									{SVGRender(
										'https://seiturju.sirv.com/Chatbiz/instagram.svg',
										'footer__info__sns--image g-image',
										20,
										21,
										'',
									)}
								</a>
								<a
									href="https://linkedin.com/company/chatbiz-id/"
									target="_blank"
									rel="noreferrer"
									className="footer__info__sns--link"
									id="mtFooterLinkLinkedin"
								>
									{SVGRender(
										'https://seiturju.sirv.com/Chatbiz/linkedin.svg',
										'footer__info__sns--image g-image',
										20,
										21,
										'',
									)}
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</Wrapper>
	);
};

export default Footer;
